import Component from 'e-submission/components/Card/UnsignedDocument'

export default (hoc) => hoc(Component)
